import React from "react";
import styled from "styled-components";
import CallIcon from "../../../../assets/MayoClinicInfo/Call.svg";

const MayoContactSection = ({ 
  subtitle = "TAVR & Angiogram Scheduler",
  phoneNumber = "1-507-266-9266",
}) => {
  return (
    <ContactContainer>
      <Title>Any questions?</Title>
      <Title>Don't hesitate to contact us</Title>
      <Subtitle>{subtitle}</Subtitle>
      <PhoneContainer>
        <PhoneLink href={`tel:${phoneNumber}`}>
          <PhoneIcon 
            src={CallIcon} 
            alt="Call" 
          />
        </PhoneLink>
      </PhoneContainer>
    </ContactContainer>
  );
};

const ContactContainer = styled.div`
  margin-left: 24px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: #1A1A1A;
  line-height: 32px;
  font-family: "Abraham", sans-serif;
`;

const Subtitle = styled.div`
  font-size: 18px;
  color: #1A1A1A;
  margin-top: 12px;
  margin-bottom: 22px;
  font-family: "Abraham", sans-serif;
`;

const PhoneContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const PhoneLink = styled.a`
  text-decoration: none;
  margin: 0;
`;

const PhoneIcon = styled.img`
  width: 48px;
  height: 48px;
`;

export default MayoContactSection;
